<div class="container">
    <div class="loader" #loader></div>
    <div class="text"
         [style.color]="textColor"
         *ngIf="text" #textElement>{{text}}</div>
  </div>
  